import { gql } from "@apollo/client";

export const GetSubsidiaries = gql`
  query GetSubsidiaries(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $empID: ID!
    $orderBy: AtsSubsidiaryOrder
    $name: String
  ) {
    GetSubsidiaries(
      token: $token
      after: $after
      customerID: $customerID
      companyID: $companyID
      empID: $empID
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          slNo
          address
          place
          state
          pin
          country
          contactPerson
          contactPersonDesign
          contactPersonEmail
          contactPersonMobile
          email
          mobile
          url
          logoFilename
          isActive
          panNo
          gstNo
          tanNo
          vatNo
          oth1No
          oth2No
          latitude
          longitude
          customerID
          enableGst
          enableTds
          enableTcs
          customerID
          companyID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

//By Ids

export const GetSubsidiaryNodeById = gql`
  query GetSubsidiaryNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsSubsidiary {
        name
        slNo
        address
        place
        state
        pin
        country
        contactPerson
        contactPersonDesign
        contactPersonEmail
        contactPersonMobile
        email
        mobile
        url
        logoFilename
        isActive
        panNo
        gstNo
        tanNo
        vatNo
        oth1No
        oth2No
        latitude
        longitude
        timeZone
        customerID
        enableGst
        enableTds
        enableTcs
        icon
      }
    }
  }
`;

export const GetSubsidiarySiteNodeById = gql`
  query GetSubsidiarySiteNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsSubsidiarySite {
        id
        name
        slNo
        address
        place
        state
        pin
        country
        contactPerson
        contactPersonDesign
        contactPersonEmail
        contactPersonMobile
        email
        mobile
        isActive
        latitude
        longitude
        icon
      }
    }
  }
`;

export const GetSubsidiarySites = gql`
  query GetSubsidiarySites(
    $token: String!
    $after: Cursor
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $empID: ID!
    $first: Int
    $orderBy: AtsSubsidiarySiteOrder
    $name: String
  ) {
    GetSubsidiarySites(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      empID: $empID
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          slNo
          address
          place
          state
          pin
          country
          contactPerson
          contactPersonDesign
          contactPersonEmail
          contactPersonMobile
          email
          mobile
          isActive
          latitude
          longitude
          customerID
          companyID
          subsidiaryID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const ValidateSubsidiarySiteForImport = gql`
  query ValidateSubsidiarySiteForImport(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryName: String!
    $siteName: String!
  ) {
    ValidateSubsidiarySiteForImport(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryName: $subsidiaryName
      siteName: $siteName
    )
  }
`;



